module.exports = __webpack_public_path__ + "img/sprinkle-5.1817f9e8.jpg";